import { handleCallApi } from '@/helpers/api-method';
import { getToastError } from '@/helpers/toast';
import ProfileService from '@/services/profile.service';

const defaults = () => ({
    compact: false,
    theme: 'light',
    planColumns: ['id', 'name', 'code', 'postingAccount', 'status'],
});

export const state = {
    ...defaults(),
    accountId: null,
    saving: false,
};

export const mutations = {
    SET_PREFERENCES(state, preferences) {
        Object.assign(state, preferences);
    },
    SET_ACCOUNT(state, accountId) {
        state.accountId = accountId;
    },
    SET_SAVING(state, saving) {
        state.saving = saving;
    },
};

export const actions = {
    async initialize({ commit, dispatch }, profile) {
        commit('SET_ACCOUNT', profile.uuid);
        let cached = {};
        try {
            cached = JSON.parse(localStorage.getItem(`ADSBASE-UI-${profile.uuid}`)) || {};
        } catch {
            localStorage.removeItem(`ADSBASE-UI-${profile.uuid}`);
        }
        await dispatch('apply', { ...defaults(), ...(profile.uiPreferences || cached) });
    },
    async apply({ state, commit, dispatch }, preferences) {
        commit('SET_PREFERENCES', preferences);
        document.documentElement.setAttribute('data-ui-density', preferences.compact ? 'compact' : 'comfortable');
        document.documentElement.setAttribute('data-layout-mode', preferences.theme);
        await dispatch('layout/changeMode', { mode: preferences.theme }, { root: true });
        await dispatch('layout/changeTopbar', { topbar: preferences.theme }, { root: true });
        localStorage.setItem(`ADSBASE-UI-${state.accountId}`, JSON.stringify(preferences));
    },
    async save({ state, commit, dispatch }, patch) {
        if (state.saving || !state.accountId) return;
        commit('SET_SAVING', true);
        try {
            const result = await handleCallApi(() => ProfileService.updateUiPreferences(patch), () => {});
            if (result?.status !== 'success') {
                getToastError(result?.message || 'Không thể lưu tùy chọn giao diện.');
                return;
            }
            await dispatch('apply', result.data);
        } finally {
            commit('SET_SAVING', false);
        }
    },
};
